import React, { useState,useEffect,useRef, use } from "react";
import { useTranslation } from 'react-i18next'
import { useRecoilState } from 'recoil';
import { unitState } from '../../plugins/recoil';
import axios from '../../plugins/axios'
import moment from "moment";

import "./A4.scss";

const V20Form = () => {
    const { t, i18n } = useTranslation()
    const isFirstRender = useRef(true);   
    const [units, setUnits] = useRecoilState(unitState)    
    const [deviceInfo, setDeviceInfo] = useState() // 선택한 디바이스 정보  
    const [patientInfo, setPatientInfo] = useState() // 선택한 환자 정보 
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [isPageReady, setIsPageReady] = useState(false);
    const [payload, setPayload] = useState(null); // ref → state로 변경

    const getUnits = async () => {
        try{
            const unitRes = await axios.get(`/measure/parameter/categories`)
            console.log('unitRes : ', unitRes);
            if (unitRes.code != '200') throw unitRes            
            setUnitInfo(unitRes.data.categories)
            return true;
        }
        catch(err){            
            console.warn(err)
            return false;
        }
    }    

    const setUnitInfo = (categories) => {
        if (!categories) return
        let nibpUnit = categories.find(category => category.name === 'NIBP')
        nibpUnit = nibpUnit.unit || nibpUnit.defaultUnit

        let ibpUnit = categories.find(category => category.name === 'IBP')
        ibpUnit = ibpUnit.unit || ibpUnit.defaultUnit

        let co2Unit = categories.find(category => category.name === 'CO2')
        co2Unit = co2Unit.unit || co2Unit.defaultUnit

        let tempUnit = categories.find(category => category.name === 'TEMP')
        tempUnit = tempUnit.unit || tempUnit.defaultUnit

        let gasUnit = categories.find(category => category.name === 'GAS')
        gasUnit = gasUnit.unit || gasUnit.defaultUnit

        setUnits({
            ...units,
            'NIBP': nibpUnit,
            'IBP': ibpUnit,
            'IBP1': ibpUnit,
            'IBP2': ibpUnit,
            'IBP3': ibpUnit,
            'IBP4': ibpUnit,
            'EtCO2': co2Unit,
            'InCO2': co2Unit,
            'Temp': tempUnit,
            'Temp1': tempUnit,
            'Temp2': tempUnit,
            'GAS': gasUnit
        })
    }

    const getLanguageType = async () => {
        try{
            const res = await axios.get('/user/me')
            if (res.code != '200') throw res

            //언어 세팅
            i18n.changeLanguage(res.data.language);            
        }
        catch(err){
            console.warn(err);
        }
    }

    // ✅ Device & Patient 정보 가져오기
    const getReportInfo = async () => {
        try{            
            const deviceId = payload?.bedInfo?.deviceId || null; // payload에서 deviceId 가져오기

            const resDevice = await axios.get(`/device/${deviceId}`);
            if (resDevice.code != '200') throw resDevice            

            let patientData = {};

            // Device 정보는 있어도 Patient 정보가 없을 수 있음.
            if(resDevice?.data?.patientId != '' && resDevice?.data?.patientId != null && resDevice?.data?.patientId != undefined){
                try {                    
                    const resPatient = await axios.get(`/patient/${resDevice?.data?.patientId}`);
                    
                    if (resPatient && resPatient.data) {
                        patientData = resPatient.data;
                    }
                } catch (patientError) {
                    console.warn('환자 정보 가져오기 실패:', patientError);
                }
            }

            setDeviceInfo(resDevice.data);
            setPatientInfo(patientData);

            return true;
        }
        catch(err){
            console.warn(err);
            return false;
        }
    }

    // 프린터 함수
    const handlePrint = () => {
        console.log('프린트 시작');
        
        // 클래스 제거 후 다시 추가 (리프레시 효과)
        document.documentElement.classList.remove("waveform-active");
        document.body.classList.remove("waveform-active");
        
        setTimeout(() => {
            document.documentElement.classList.add("waveform-active");
            document.body.classList.add("waveform-active");
            
            setTimeout(() => {
                console.log('페이지 수:', document.querySelectorAll('.a4-page').length);
                window.print();
            }, 500);
        }, 100);
    };

    useEffect(() => {        
        if(payload){            
            const style = document.createElement("style");
                style.innerHTML = `
                @page {
                    size: 2480px 3508px;
                    margin: 0;
                }
                `;
            document.head.appendChild(style);

            // 스타일 클래스 추가
            document.documentElement.classList.add("waveform-active");
            document.body.classList.add("waveform-active");        
            
            getLanguageType();
            getReportInfo(); //Device & Patient정보 가져오기.

            return () => {
                document.documentElement.classList.remove("waveform-active");
                document.body.classList.remove("waveform-active");
                document.head.removeChild(style); // 라우트 빠져나갈 때 제거
            };
        }
    }, [payload]);

    useEffect(() => {

        //setPayload(dummyData) // 테스트용 더미 데이터 세팅

        // 메시지 수신 리스너 등록
        const handleMessage = (event) => {
            if (event.data?.name === "LOAD_REPORT_DATA") {
                //console.log('event.data.payload : ',event.data.payload);
                setPayload(event.data.payload); // 받은 데이터를 state에 저장
            }
        };
        window.addEventListener("message", handleMessage);

        // 부모 창에 "준비 완료" 알림
        window.opener?.postMessage({ name: "READY" }, "*");

        return () => window.removeEventListener("message", handleMessage);        
    }, []);

    useEffect(() => {
    
            if (isFirstRender.current) {
                isFirstRender.current = false; // 초기 렌더링 후 플래그 업데이트
                return;
            }
    
            const loadAllData = async () => {
                //console.log('데이터 로딩 시작...');
                
                try {
                    // 모든 비동기 작업을 병렬로 실행
                    const [units] = await Promise.all([
                        getUnits(),
                    ]);
    
                    if (units) {
                        console.log('모든 데이터 로딩 완료');
                        setIsDataLoaded(true);
                    } else {
                        console.error('데이터 로딩 실패');
                    }
                } catch (error) {
                    console.error('데이터 로드 중 에러:', error);
                }
            };
    
            loadAllData();
        }, [deviceInfo,patientInfo]);    
    
        // 데이터 로드 완료 후 렌더링 완료 대기
        useEffect(() => {
            if (isDataLoaded) {
                //console.log('페이지 렌더링 대기 중...');
                
                // DOM 렌더링 및 Canvas 그리기 완료를 위한 충분한 대기 시간
                const renderTimer = setTimeout(() => {
                    //console.log('페이지 렌더링 완료');
                    setIsPageReady(true);
                }, 1500); // Canvas 렌더링을 고려한 여유 시간
    
                return () => clearTimeout(renderTimer);
            }
        }, [isDataLoaded]);

    // 페이지 준비 완료 시 자동 프린트
    useEffect(() => {
        if (isPageReady) {
            // URL 파라미터로 자동 프린트 제어
            const urlParams = new URLSearchParams(window.location.search);
            const autoPrint = urlParams.get('autoPrint');
            const delay = parseInt(urlParams.get('delay')) || 3000;
            
            if (autoPrint === 'true' || autoPrint === null) { // 기본값은 자동 프린트
                setTimeout(() => {
                    handlePrint(); // 자동 프린트 잠시 스탑
                }, delay);
            }
        }
    }, [isPageReady]);

    //인쇄 하거나 취소하고 창 꺼지기
    window.onafterprint = () => {
        setTimeout( () => {
            window.close();
        },1000)
    };

    // 스타일 정의
    const patientInfoFontBold = 'text-black font-medium text-[48px] leading-[110%] font-pretendard';
    const patientInfoFont = 'text-black font-thin text-[36px] leading-[40px] font-pretendard';
    const tableHeaderFont = 'text-black text-center font-pretendard text-[28px] font-medium leading-[110%] bg-[#fff] py-[24px]';
    const tableBodyFont = 'text-black text-center font-pretendard text-[32px] font-light leading-[110%] py-[16px]';
    const tableLine = 'border-b-[1px] border-opacity-50 border-[#5E5E5E]';
    const waveFont = 'text-black font-pretendard text-[28px] font-medium leading-[110%]';

    return <div className="document-container bg-gray-100 p-20 font-sans min-h-screen">
            <div className="a4-page mx-auto bg-white shadow-lg relative box-border">
                <div className="w-full h-full flex flex-col px-[146px] pt-[140px] pb-[66px]">
                    {/* Header */}
                    <div className={`${patientInfoFontBold} w-full flex items-center justify-start mb-[24px] border-b border-[#5E5E5E] pb-[24px]`}>
                        <h1 className="mr-[80px] ">
                            <span>{t('print.common.patientId')} : </span>
                            <span>[{patientInfo?.devicePatientId || '---'}]</span>
                        </h1>
                        <h1 className="text-black font-medium text-[48px] leading-[110%] ">
                            <span>{t('print.common.name')} : </span>
                            <span>[{patientInfo?.name || '---'}]</span>
                        </h1>
                    </div>
                    {/* Patient Info */}
                    <div className={`${patientInfoFont} w-full flex items-center justify-between flex-wrap py-[32px] mb-[96px]`}>
                        <div className="w-full flex mb-[32px]">
                            <div className="mr-[64px]">
                                <strong className={`${patientInfoFont}`}>{t('print.common.admitted')}  :  </strong>
                                {/* <span>{moment().format('YYYY-MM-DD HH:mm')}</span> */}
                                <span>{patientInfo?.createdAt ? moment(patientInfo?.createdAt).format('YYYY-MM-DD HH:mm') : '-'}</span>
                            </div>
                            {/* <div>
                                <strong className={`${patientInfoFont}`}>Location  : </strong>
                                <span>{patientInfo?.address || ''}</span>
                            </div> */}
                        </div>
                        <div className="w-full flex mb-[32px]">
                            <div className="mr-[64px]">
                                <strong className={`${patientInfoFont}`}>{t('print.common.gender')}  :  </strong>
                                <span>{patientInfo?.gender === 'M' ? t('print.common.male') : patientInfo?.gender === 'F' ? t('print.common.female') : t('print.common.notSelected')} , </span>
                            </div>
                            <div className="mr-[64px]">
                                <strong className={`${patientInfoFont}`}>{t('print.common.height')}  :  </strong>
                                <span>{patientInfo?.height || '---'} , </span>
                            </div>
                            <div className="mr-[64px]">
                                <strong className={`${patientInfoFont}`}>{t('print.common.weight')}  :  </strong>
                                <span>{patientInfo?.weight || '--'} , </span>
                            </div>
                            <div className="mr-[64px]">
                                <strong className={`${patientInfoFont}`}>{t('print.waveForm.birthday')}  :  </strong>
                                <span>{patientInfo?.birthDate || '------'} , </span>
                            </div>
                            <div>
                                <strong className={`${patientInfoFont}`}>{t('print.waveForm.phoneNumber')}  :  </strong>
                                <span>{patientInfo?.phoneNumber || '-----'} , </span>
                            </div>
                        </div>   
                        <div className="w-full flex mb-[32px]">
                            <div className="mr-[64px]">
                                <strong className={`${patientInfoFont}`}>{t('print.waveForm.emergencyContactName')}  :  </strong>
                                <span>{patientInfo?.protectorName || '-----'} , </span>
                            </div>
                            <div>
                                <strong className={`${patientInfoFont}`}>{t('print.waveForm.phoneNumber')}  :  </strong>
                                <span>{patientInfo?.protectorPhoneNumber || '-----'}</span>
                            </div>
                        </div>
                        <div className="w-full flex mb-[32px] pb-[32px] border-b border-[#5E5E5E] border-opacity-50">
                            <div className="break-all">
                                <strong className={`${patientInfoFont}`}>{t('print.waveForm.address')}  :  </strong>
                                <span>{patientInfo?.address || '-----'}</span>
                            </div>
                        </div> 
                        <div className="w-full flex mb-[32px]">
                            <div className="mr-[64px]">
                                <strong className={`${patientInfoFont}`}>{t('print.waveForm.doctor')}1 :  </strong>
                                <span>{patientInfo?.doctor1?.doctorName || '----'} , </span>
                            </div>
                            <div className="mr-[64px]">
                                <strong className={`${patientInfoFont}`}>{t('print.waveForm.phoneNumber')}  :  </strong>
                                <span>{patientInfo?.doctor1?.doctorPhoneNumber || '-----'}</span>
                            </div>
                            <div className="mr-[64px]">
                                <strong className={`${patientInfoFont}`}>{t('print.waveForm.doctor')}2 :  </strong>
                                <span>{patientInfo?.doctor2?.doctorName || '----'} , </span>
                            </div>
                            <div>
                                <strong className={`${patientInfoFont}`}>{t('print.waveForm.phoneNumber')}  :  </strong>
                                <span>{patientInfo?.doctor2?.doctorPhoneNumber || '-----'}</span>
                            </div>
                        </div>
                        <div className="w-full flex pb-[32px] border-b border-[#5E5E5E] border-opacity-50">
                            <div className="mr-[64px]">
                                <strong className={`${patientInfoFont}`}>{t('print.waveForm.nurse')}1 :  </strong>
                                <span>{patientInfo?.nurse1?.nurseName || '----'} , </span>
                            </div>
                            <div className="mr-[64px]">
                                <strong className={`${patientInfoFont}`}>{t('print.waveForm.phoneNumber')}  :  </strong>
                                <span>{patientInfo?.nurse1?.nursePhoneNumber || '-----'}</span>
                            </div>
                            <div className="mr-[64px]">
                                <strong className={`${patientInfoFont}`}>{t('print.waveForm.nurse')}2 :  </strong>
                                <span>{patientInfo?.nurse2?.nurseName || '----'} , </span>
                            </div>
                            <div>
                                <strong className={`${patientInfoFont}`}>{t('print.waveForm.phoneNumber')}  :  </strong>
                                <span>{patientInfo?.nurse2?.nursePhoneNumber || '-----'}</span>
                            </div>
                        </div>                        
                    </div>
                    <div>
                        <div className="text-black font-pretendard text-[40px] font-medium leading-[120%] mb-[24px] flex flex-col gap-[10px]">                            
                            <p>{t('print.waveForm.recordTime')} : {payload?.v20Data?.recordTimestamp ? moment(payload?.v20Data?.recordTimestamp).format('YYYY-MM-DD HH:mm:ss') : '---'}</p> 
                            <p>NIBP : {payload?.v20Data?.numericData?.nibpSysValue || '---'}/{payload?.v20Data?.numericData?.nibpDiaValue || '---'} ({payload?.v20Data?.numericData?.nibpMapValue || '---'}) {units['NIBP']}</p>
                            <p>PR({payload?.v20Data?.numericData?.hrprSource == 'SpO2' ? 'S' : 'N'}) : {payload?.v20Data?.numericData?.prValue || '---'} {units['PR']}</p>
                            <p>SpO2 : {payload?.v20Data?.numericData?.spO2Value || '---'} {units['SpO2']}</p>
                            <p>TEMP : {payload?.v20Data?.numericData?.t1Value || '---'} {units['Temp1']}</p>                            
                        </div>
                    </div>
                </div>
            </div>                       
        </div>;
};

export default V20Form;

